import config from '../config';
import TokenService from './token-service';

const authHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `${TokenService.getAuthToken()}`,
});

const handle = async (response) => {
  const payload = await response.json().catch(() => ({}));
  if (!response?.ok) {
    const message = payload?.error || payload?.message || `Request failed (${response.status})`;
    throw new Error(message);
  }
  return payload;
};

const AdminService = {
  async getOrphanContacts() {
    const response = await fetch(`${config.API_ENDPOINT}/admin/orphan-contacts`, {
      method: 'GET',
      headers: authHeaders(),
    });
    return handle(response);
  },

  // Re-fetches the contact from Zoho and re-triggers upsertContactFromCRM. Idempotent.
  async resyncContact(crmId) {
    const response = await fetch(`${config.API_ENDPOINT}/admin/resync-contact/${encodeURIComponent(crmId)}`, {
      method: 'POST',
      headers: authHeaders(),
    });
    return handle(response);
  },

  // Transactionally links contacts.user_id = userId and users.crm_contact_id = crmId.
  // The response also reports downstream Auth0 state: auth0 { status, authUserId,
  // detail } for the login email, and email_mismatch { login_email, contact_email }
  // (null when the linked contact's email matches the login email).
  async relink(userId, crmId) {
    const response = await fetch(`${config.API_ENDPOINT}/admin/relink`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ userId, crmId }),
    });
    return handle(response);
  },

  // Finds or repairs the Auth0 identity for a user's current DB email. With only
  // userId it is a read-only check when the account is healthy; oldEmail migrates
  // an identity sitting under a pre-merge address; createIfMissing provisions a
  // fresh one (backend generates an unshared password — the user must run a
  // normal password reset before first login).
  // NOTE: responds 200 even when nothing was fixed ('needs_manual', 'ambiguous')
  // — callers must branch on auth0.status, not the HTTP code.
  async reconcileAuth0({ userId, oldEmail, createIfMissing }) {
    const response = await fetch(`${config.API_ENDPOINT}/admin/reconcile-auth0`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ userId, oldEmail, createIfMissing }),
    });
    return handle(response);
  },
};

export default AdminService;
